module.exports = __webpack_public_path__ + "img/mockup.abf40849.png";